import { call, put } from "redux-saga/effects";
import Axios from "../../utils/axios";
import { showErrorSnackbar } from "../../utils/util";
import { STRETCH_FETCH_USER_PURCHASES } from "../../state/user/constants";
import { fetchUserPurchasesDone } from "../../state/user/actions";

function* fetchUserPurchases({ userId }) {
  try {
    const result = yield call(() =>
      Axios.core.get(`${STRETCH_FETCH_USER_PURCHASES}/${userId}`)
    );
    yield put(fetchUserPurchasesDone(result.data));
  } catch (e) {
    const errorMessage = JSON.parse(e.request.response).message;
    showErrorSnackbar(errorMessage, {
      removeOnHover: false
    });
    yield put(fetchUserPurchasesDone([]));
  }
}

export default fetchUserPurchases;
